export default <T>(value: T | T[]) => (Array.isArray(value) ? value : [value]);
